import styled from "styled-components";

export type FooterProps = { height: number };
export const Footer = styled.div.attrs<FooterProps>(props => ({
    style: {
        flex: `0 1 ${props.height}px`
    }
}))<FooterProps>``;